import { Box, Container } from "@mui/material";
import { useEffect } from "react";
import { navigate } from "gatsby";
import { useGetMyQuickLoan } from "../../../hooks/scenario.hooks";
import { LoadingBackdrop } from "../../../components/loading-backdrop";
import Footer from "../../../components/footer";
import SignupBanner from "../../../components/signup-banner-left";
import PartnerLogoBanner from "../../../components/PartnerLogoBanner";

const PreLoanApplicationLayout = ({ children }) => {
  const { data: myQuickLoan, isLoading: isCheckingDraft } = useGetMyQuickLoan({
    enabled: true,
    retry: (failureCount, error) => {
      // Don't retry on 401 (unauthorized) errors
      if (error?.status === 401) {
        return false;
      }
      // Retry by default (react-query default is 3 retries)
      return failureCount < 2;
    },
  });

  // Check if user has a draft loan and redirect to main loan application
  useEffect(() => {
    if (
      !isCheckingDraft &&
      myQuickLoan &&
      myQuickLoan.scenarioObject &&
      Object.keys(myQuickLoan.scenarioObject).length > 0
    ) {
      navigate("/loan-application");
    }
  }, [myQuickLoan, isCheckingDraft]);

  if (isCheckingDraft) {
    return <LoadingBackdrop />;
  }

  return (
    <div className="my-account-body">
      <div className="login-wrapper pre-loan-wrapper">
        <SignupBanner />
        <div className="pre-loan-content-wrapper">
          <Box className="pre-loan-logo-container">
            <PartnerLogoBanner />
          </Box>
          <Container maxWidth="sm" className="pre-loan-content-container">
            {children}
          </Container>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PreLoanApplicationLayout;
